import React, { useState, ChangeEvent, KeyboardEvent, FC } from 'react';
import { Box, Button, Grid, Stack, TextField } from '@mui/material';

interface WordInputProps {
  checkWordHandler: (word: string) => void;
}

const WordInput: FC<WordInputProps> = ({ checkWordHandler }) => {
  const [values, setValues] = useState<string[]>(['', '', '', '', '']);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    const newValue = e.target.value;
    if (newValue.length <= 1) {
      const newValues = [...values];
      newValues[index] = newValue;
      setValues(newValues);

      // Move focus to the next box if the input is valid
      if (newValue && index < values.length - 1) {
        const nextSibling = document.querySelector<HTMLInputElement>(
          `#input-${index + 1}`
        );
        if (nextSibling) nextSibling.focus();
      }
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'Backspace' && !values[index] && index > 0) {
      const prevSibling = document.querySelector<HTMLInputElement>(
        `#input-${index - 1}`
      );
      if (prevSibling) prevSibling.focus();
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Stack
        direction="column"
        spacing={2}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {/* <Grid container direction="row" spacing={2} justifyContent="center"> */}
        <Stack
          direction="row"
          spacing={2}
          //justifyContent="center"
          //alignItems="center"
        >
          {values.map((value, index) => (
            // <Grid item key={index}>
            <TextField
              key={index}
              variant="standard"
              id={`input-${index}`}
              value={value.toUpperCase()}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              inputProps={{
                maxLength: 1,
                style: {
                  textAlign: 'center',
                  fontSize: '2rem',
                  width: '2.4rem',
                  borderRadius: 4,
                  //   border: '4px solid #2B2B2B',
                  border: 'none',
                  outline: 'none',
                  color: '#fff',
                },
              }}
              //   sx={{
              //     '& .MuiInput-root': {
              //       border: 'none', // Custom border
              //       borderRadius: '4px', // Custom border-radius
              //       width: '2rem', // Adjust width to include padding/borders
              //       padding: '1.3rem',
              //       '&:hover': {
              //         borderColor: '#1A73E8', // Change border color on hover
              //       },
              //       '&.Mui-focused': {
              //         // borderColor: '#FF5722', // Change border color when focused
              //         // boxShadow: '0 0 5px #FF5722', // Optional glow effect
              //       },
              //     },
              //   }}
            />
          ))}
        </Stack>
        {/* </Grid> */}
        <Button
          variant="outlined"
          sx={(theme) => ({
            border: '2px solid #2B2B2B',
            // borderRadius: 20,
            height: 50,
            width: 275,
          })}
          onClick={() => checkWordHandler(values.join(''))}
        >
          Submit
        </Button>
      </Stack>
    </Box>
  );
};

export default WordInput;
